/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Role_Franchise_Manager16Inputs */

const cs_role_franchise_manager16 = /** @type {(inputs: Role_Franchise_Manager16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franchise manažer`)
};

const en_role_franchise_manager16 = /** @type {(inputs: Role_Franchise_Manager16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franchise manager`)
};

/**
* | output |
* | --- |
* | "Franchise manager" |
*
* @param {Role_Franchise_Manager16Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
const role_franchise_manager16 = /** @type {((inputs?: Role_Franchise_Manager16Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_Franchise_Manager16Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_role_franchise_manager16(inputs)
	return cs_role_franchise_manager16(inputs)
});
export { role_franchise_manager16 as "role_FRANCHISE_MANAGER" }